export default __webpack_public_path__ + "static/media/courier-tracking-cargo-bike.aae95cec.svg";